export default "__VITE_ASSET__0c34a5f9__"